import { useEffect, useState, useRef } from "react";
import { postAxios } from "../../util/apiCall";
import { Html5Qrcode } from "html5-qrcode";
import moment from "moment";
import axios from "axios";

export const useLkm = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);
  const ref = useRef(null);

  const [popUpNewLkm, setPopUpNewLkm] = useState(false);
  const [jenisLkm, setJenisLkm] = useState("Jenis LKM");
  const [keBagian, setKeBagian] = useState("Ke Bagian");
  const [dataListMold, setDataListMold] = useState();
  const [customerNewLkm, setCustomerNewLkm] = useState("Customer");
  const [moldNewLkm, setMoldNewLkm] = useState(null);
  const [mesinNewLkm, setMesinNewLkm] = useState("Mesin");

  const [perbaikan, setPerbaikan] = useState("");
  const [pencegahan, setPencegahan] = useState("");

  const [isError, setIsError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [popUpQrCode, setPopUpQrCode] = useState(false);
  const [qrCode, setQrCode] = useState();

  const [deskripsiKerusakan, setDeskripsiKerusakan] = useState([
    { bagianRusak: "", penyebab: "" },
  ]);

  const [subMenu, setSubMenu] = useState("open");

  const [isRefresh, setIsRefresh] = useState(false);
  const [dataListLkm, setDataListLkm] = useState();
  const [dataAnalytics, setDataAnalytics] = useState();

  const [popUpDetailLkm, setPopUpDetailLkm] = useState(false);
  const [pickDetailLkm, setPickDetailLkm] = useState();

  const [filterBulanLkm, setFilterBulanLkm] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahunLkm, setFilterTahunLkm] = useState(
    moment().utcOffset("+0700").year()
  );
  const [filterJenisLkm, setFilterJenisLkm] = useState("Jenis");
  const [filterItemLkm, setFilterItemLkm] = useState();

  const [popUpScan, setPopUpScan] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [dataHeader, setDataHeader] = useState();

  const [editPerbaikan, setEditPerbaikan] = useState();
  const [editPencegahan, setEditPencegahan] = useState();

  useEffect(() => {
    const filterMonth = `${filterTahunLkm}-${("0" + filterBulanLkm).slice(-2)}`;
    const url = `${process.env.REACT_APP_ENDPOINT}/getListLkm`;

    if (subMenu === "analytics") {
      postAxios(
        url,
        { tim: dataUser.tim, type: "analytics", filterYear: filterTahunLkm },
        dataUser.auth,
        setDataAnalytics,
        ""
      );
    } else {
      postAxios(
        url,
        { tim: dataUser.tim, type: subMenu, filterMonth },
        dataUser.auth,
        setDataListLkm,
        ""
      );
    }

    const filterBulanSebelumnya = moment(filterMonth)
      .add(-1, "months")
      .format("YYYY-MM");

    postAxios(
      url,
      {
        tim: dataUser.tim,
        type: "header",
        filterMonth,
        filterBulanSebelumnya,
      },
      dataUser.auth,
      setDataHeader,
      ""
    );
    setIsRefresh(false);
  }, [subMenu, isRefresh, filterTahunLkm, filterBulanLkm]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListMold`,
      { tim: dataUser.tim },
      dataUser.auth,
      setDataListMold,
      ""
    );
  }, []);

  const handleCloseNewLkm = () => {
    setPopUpNewLkm(false);
    setMesinNewLkm("Mesin");
    setMoldNewLkm(null);
    setCustomerNewLkm("Customer");
    setKeBagian("Ke Bagian");
    setJenisLkm("Jenis LKM");
    setPencegahan("");
    setPerbaikan("");
    setIsError(false);
    setIsDisabled(false);
    setDeskripsiKerusakan([{ bagianRusak: "", penyebab: "" }]);
  };

  let dataTempMold = [];
  dataListMold &&
    dataListMold.forEach((data) => {
      if (data.company === customerNewLkm) {
        data.data.forEach((element) => {
          dataTempMold.push({ label: element.name, value: element.name });
        });
      }
    });

  const addFields = () => {
    setDeskripsiKerusakan([
      ...deskripsiKerusakan,
      { bagianRusak: "", penyebab: "" },
    ]);
  };

  const removeFields = () => {
    if (deskripsiKerusakan.length > 1) {
      setDeskripsiKerusakan(deskripsiKerusakan.slice(0, -1));
    }
  };

  const handleFormChange = (index, event) => {
    let data = [...deskripsiKerusakan];
    data[index][event.target.name] = event.target.value;
    setDeskripsiKerusakan(data);
  };

  const handleSubmitNewLkm = () => {
    const filteredArray = deskripsiKerusakan.filter(
      (element) => element.bagianRusak !== ""
    );

    if (
      mesinNewLkm !== "Mesin" &&
      moldNewLkm &&
      customerNewLkm !== "Customer" &&
      keBagian !== "Ke Bagian" &&
      jenisLkm !== "Jenis LKM"
    ) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/newLkm`,
        {
          tim: dataUser.tim,
          userId: dataUser.id,
          keBagian,
          jenisLkm,
          mesin: mesinNewLkm,
          customer: customerNewLkm,
          mold: moldNewLkm.value,
          penyebab: filteredArray,
          deskripsiPerbaikan: perbaikan,
          deskripsiPencegahan: pencegahan,
        },
        dataUser.auth,
        "",
        ""
      );
      handleCloseNewLkm();
    } else {
      setIsError(true);
      setIsDisabled(false);
    }
  };

  const openDetailLkm = (data) => {
    setPopUpDetailLkm(true);
    setPickDetailLkm(data);
    setEditPerbaikan(data && data.deskripsiPerbaikan);
    setEditPencegahan(data && data.deskripsiPencegahan);
  };

  const handleCloseDetailLkm = () => {
    setPopUpDetailLkm(false);
    setPickDetailLkm();
    setEditPencegahan();
    setEditPerbaikan();
  };

  let reFormat = [];
  dataListLkm &&
    dataListLkm.forEach((element) => {
      if (filterJenisLkm === "MOLD" || filterJenisLkm === "BAHAN") {
        reFormat.push({ value: element.mold, label: element.mold });
      } else if (filterJenisLkm === "MESIN") {
        reFormat.push({ value: element.mesin, label: element.mesin });
      }
    });

  const handleResetFilterLkm = () => {
    setFilterBulanLkm(moment().utcOffset("+0700").month() + 1);
    setFilterTahunLkm(moment().utcOffset("+0700").year());
    setFilterJenisLkm("Jenis");
    setFilterItemLkm();
  };

  const searchFeatureLkm = () => {
    if (filterJenisLkm !== "Jenis" || filterItemLkm) {
      let searchName = [];
      dataListLkm &&
        dataListLkm.forEach((value) => {
          if (filterJenisLkm === "MESIN") {
            if (filterItemLkm) {
              if (
                value.mesin.includes(filterItemLkm.value) &&
                value.jenisLkm.includes(filterJenisLkm)
              ) {
                searchName.push(value);
              }
            } else if (value.jenisLkm.includes(filterJenisLkm)) {
              searchName.push(value);
            }
          } else if (filterJenisLkm === "MOLD" || filterJenisLkm === "BAHAN") {
            if (filterItemLkm) {
              if (
                value.mold.includes(filterItemLkm.value) &&
                value.jenisLkm.includes(filterJenisLkm)
              ) {
                searchName.push(value);
              }
            } else if (value.jenisLkm.includes(filterJenisLkm)) {
              searchName.push(value);
            }
          }
        });
      return searchName;
    }
    return dataListLkm;
  };
  let dataTempPoSearch = searchFeatureLkm();

  const handleScan = () => {
    if (popUpScan) {
      const html5QrCode = new Html5Qrcode("qr");

      const qrCodeSuccessCallback = async (decodedText) => {
        if (decodedText) {
          html5QrCode.pause();
          const { data } = await axios.post(
            `${process.env.REACT_APP_ENDPOINT}/scanLkm`,
            {
              tim: dataUser.tim,
              userId: dataUser.id,
              name: dataUser.name,
              role: dataUser.role,
              qrCode: JSON.parse(decodedText),
            },
            { headers: { Authorization: `Bearer ${dataUser.auth}` } }
          );

          if (data.data === 200) {
            setErrMsg("");
            setPopUpScan(false);
            setIsRefresh(true);
          } else {
            setErrMsg(data.message);
          }
          html5QrCode.stop().then(() => {
            html5QrCode.clear();
          });
        }
      };
      const onScanFailed = (err) => {
        console.log(err);
      };
      const config = { fps: 10, qrbox: { width: 250, height: 250 } };
      html5QrCode.start(
        { facingMode: "environment" },
        config,
        qrCodeSuccessCallback,
        onScanFailed
      );
      setErrMsg("");
    }
  };

  useEffect(() => {
    if (popUpScan) {
      handleScan();
    }
  }, [popUpScan]);

  const handleApprove = async (type) => {
    await postAxios(
      `${process.env.REACT_APP_ENDPOINT}/approveLkm`,
      {
        tim: dataUser.tim,
        name: dataUser.name,
        type,
        id: pickDetailLkm.id,
      },
      dataUser.auth,
      "",
      ""
    );
    handleCloseDetailLkm();
    setIsRefresh(true);
  };

  const handleEditPerbaikan = async () => {
    await postAxios(
      `${process.env.REACT_APP_ENDPOINT}/editLkm`,
      {
        tim: dataUser.tim,
        name: dataUser.name,
        id: pickDetailLkm.id,
        editPerbaikan,
        editPencegahan,
      },
      dataUser.auth,
      "",
      ""
    );
    handleCloseDetailLkm();
    setIsRefresh(true);
    setIsDisabled(false);
  };

  return {
    dataUser,
    popUpNewLkm,
    setPopUpNewLkm,
    handleCloseNewLkm,
    jenisLkm,
    setJenisLkm,
    keBagian,
    setKeBagian,
    customerNewLkm,
    setCustomerNewLkm,
    dataListMold,
    moldNewLkm,
    setMoldNewLkm,
    mesinNewLkm,
    setMesinNewLkm,
    dataTempMold,
    deskripsiKerusakan,
    handleFormChange,
    addFields,
    removeFields,
    perbaikan,
    setPerbaikan,
    pencegahan,
    setPencegahan,
    handleSubmitNewLkm,
    isError,
    isDisabled,
    setIsDisabled,
    subMenu,
    setSubMenu,
    setIsRefresh,
    dataListLkm,
    dataAnalytics,
    popUpDetailLkm,
    openDetailLkm,
    handleCloseDetailLkm,
    pickDetailLkm,
    setPickDetailLkm,
    popUpQrCode,
    setPopUpQrCode,
    qrCode,
    setQrCode,
    filterBulanLkm,
    setFilterBulanLkm,
    filterTahunLkm,
    setFilterTahunLkm,
    filterJenisLkm,
    setFilterJenisLkm,
    filterItemLkm,
    setFilterItemLkm,
    reFormat,
    handleResetFilterLkm,
    dataTempPoSearch,
    popUpScan,
    setPopUpScan,
    ref,
    errMsg,
    handleScan,
    handleApprove,
    dataHeader,
    editPerbaikan,
    setEditPerbaikan,
    editPencegahan,
    setEditPencegahan,
    handleEditPerbaikan,
  };
};
